export const ROLES = { CLIENT: 'client', REP: 'rep', TEAM_LEAD: 'team_lead', ADMIN: 'admin' };

export const DOC_STATUS = {
  MISSING: 'Missing',
  REQUESTED: 'Requested',
  UPLOADED: 'Uploaded',
  UNDER_REVIEW: 'Under Review',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  NEEDS_REUPLOAD: 'Needs Reupload',
};

export const DOC_CATEGORIES = [
  // The order here is the order of the Folders list, top to bottom.
  { id: 'application', label: 'Application', icon: '📋', required: true },
  { id: 'bank_statements', label: 'Bank Statements', icon: '🏦', required: true },
  // Anything else that should go with a lender submission. Not required, so
  // it never counts as a missing document.
  { id: 'additional_submission_docs', label: 'Additional Submission Docs', icon: '📎', required: false },
  { id: 'other', label: 'Other', icon: '📂', required: false },
  { id: 'credit_report', label: 'Credit Report', icon: '📊', required: false },
  // Everything in it goes to the equipment lenders in place of bank
  // statements, and a send to one of them is blocked while it's empty - see
  // EQUIPMENT_INVOICE_LENDERS in AutoSubmit.jsx and routes/autoSubmit.js.
  // Used to be a subfolder of Additional Submission Docs; now its own folder.
  { id: 'equipment_invoice', label: 'Equipment', icon: '🧾', required: false },
  // JRW Capital's application - sent to JRW in place of the Submission App,
  // and a JRW send is blocked while it's empty. Used to sit inside Equipment.
  { id: 'jrw_app', label: 'JRW App', icon: '📄', required: false },
  // CAN Equipment's own file - an Excel workbook. Everything in here goes to
  // CAN Equipment along with the Equipment folder and the Submission App
  // (see selectExtraSubmissionDocs in routes/autoSubmit.js).
  { id: 'can_equipment', label: 'CAN Equipment', icon: '🚜', required: false },
  { id: 'drivers_license', label: "Driver's License / ID", icon: '🪪', required: true },
  { id: 'voided_check', label: 'Voided Check', icon: '✅', required: true },
  { id: 'admin_app_ne', label: 'Submission App', icon: '🗃️', required: false },
  { id: 'admin_app', label: 'Auto App', icon: '🗂️', required: false },
  // Journey-only - same as Submission App, but every page of the signed
  // envelope is kept (DocuSign's own Certificate of Completion included)
  // instead of trimming to page 1. See appVariants.js's own comment on the
  // `journey` variant.
  { id: 'admin_app_journey', label: 'Journey App', icon: '📜', required: false },
  // Deleting a document moves it here rather than destroying it, and it can be
  // restored to the folder it came from or removed for good. Sits last so it
  // reads as the end of the list rather than as another folder documents are
  // meant to live in.
  { id: 'trash', label: 'Trash', icon: '🗑️', required: false },
];

export const USERS = [
  { id: 'u1', name: 'Alex Stetkevych', email: 'alexs@capital-infusion.com', password: 'CapitalAdmin2024!', role: ROLES.ADMIN, repId: null, clientId: null },
  { id: 'u-careem', name: 'Careem Roberts', email: 'careem@capital-infusion.com', password: 'Careem1', role: ROLES.ADMIN, repId: null, clientId: null },
  { id: 'u-anthony', name: 'Anthony Diaz', email: 'anthonyd@capital-infusion.com', password: 'anthony$cool123!', role: ROLES.REP, repId: 'r-anthony', clientId: null, manages: ['r-nik'] },
  { id: 'u-nik', name: 'Nikholas Lazo', email: 'nikholas@capital-infusion.com', password: 'AppPullingBeast23', role: ROLES.REP, repId: 'r-nik', clientId: null, reportsTo: 'r-anthony' },
  { id: 'u-chris', name: 'Christopher Cranton', email: 'christopher.cranton@gmail.com', password: 'chrisbuildstech123', role: ROLES.CLIENT, repId: null, clientId: 'c-chris' },
  { id: 'u2', name: 'Sarah Mitchell', email: 'rep@demo.com', password: 'password', role: ROLES.REP, repId: 'r1', clientId: null },
  { id: 'u3', name: 'James Carter', email: 'rep2@demo.com', password: 'password', role: ROLES.REP, repId: 'r2', clientId: null },
  { id: 'u4', name: 'Darnell Williams', email: 'client@demo.com', password: 'password', role: ROLES.CLIENT, repId: null, clientId: 'c1' },
  { id: 'u5', name: 'Maria Gonzalez', email: 'client2@demo.com', password: 'password', role: ROLES.CLIENT, repId: null, clientId: 'c2' },
  { id: 'u6', name: 'Tony Russo', email: 'client3@demo.com', password: 'password', role: ROLES.CLIENT, repId: null, clientId: 'c3' },
];

export const REPS = [
  { id: 'r-anthony', name: 'Anthony Diaz', email: 'anthonyd@capital-infusion.com', team: 'Capital Infusion', active: true, phone: '', manages: ['r-nik'] },
  { id: 'r-nik', name: 'Nikholas Lazo', email: 'nikholas@capital-infusion.com', team: 'Capital Infusion', active: true, phone: '', reportsTo: 'r-anthony' },
  { id: 'r1', name: 'Sarah Mitchell', email: 'rep@demo.com', team: 'East Coast', active: true, phone: '(212) 555-0101' },
  { id: 'r2', name: 'James Carter', email: 'rep2@demo.com', team: 'West Coast', active: true, phone: '(310) 555-0202' },
];

export const CLIENTS = [
  { id: 'c-chris', businessName: 'Cranton Consulting', ownerName: 'Christopher Cranton', assignedRepId: 'r-nik', status: 'Active', email: 'christopher.cranton@gmail.com', phone: '', industry: 'Technology', requestedAmount: 0, state: '' },
  { id: 'c1', businessName: 'Williams Auto Repair', ownerName: 'Darnell Williams', assignedRepId: 'r1', status: 'Active', email: 'client@demo.com', phone: '(404) 555-0301', industry: 'Automotive', requestedAmount: 75000, state: 'GA' },
  { id: 'c2', businessName: 'Gonzalez Catering Co.', ownerName: 'Maria Gonzalez', assignedRepId: 'r1', status: 'Pending', email: 'client2@demo.com', phone: '(305) 555-0302', industry: 'Food & Beverage', requestedAmount: 50000, state: 'FL' },
  { id: 'c3', businessName: 'Russo Plumbing LLC', ownerName: 'Tony Russo', assignedRepId: 'r2', status: 'Under Review', email: 'client3@demo.com', phone: '(718) 555-0303', industry: 'Construction', requestedAmount: 120000, state: 'NY' },
  { id: 'c4', businessName: 'Bright Horizons Daycare', ownerName: 'Linda Park', assignedRepId: 'r2', status: 'Approved', email: 'linda@demo.com', phone: '(213) 555-0304', industry: 'Education', requestedAmount: 40000, state: 'CA' },
];

export const DOCUMENTS = [];

export const DOCUMENT_REQUESTS = [];

export const ACTIVITY_LOG = [];

export const getClientsByRep = (repId) => {
  const rep = REPS.find(r => r.id === repId);
  const repIds = [repId];
  if (rep?.manages) repIds.push(...rep.manages);
  return CLIENTS.filter(c => repIds.includes(c.assignedRepId));
};
export const getDocumentsByClient = (clientId) => DOCUMENTS.filter(d => d.clientId === clientId);
export const getDocumentsByCategory = (clientId, category) => DOCUMENTS.filter(d => d.clientId === clientId && d.category === category);
export const getRequestsByClient = (clientId) => DOCUMENT_REQUESTS.filter(r => r.clientId === clientId);
export const getActivityByClient = (clientId) => ACTIVITY_LOG.filter(a => a.clientId === clientId).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
export const getMissingCategories = (clientId) => {
  const uploaded = new Set(getDocumentsByClient(clientId).map(d => d.category));
  return DOC_CATEGORIES.filter(c => c.required && !uploaded.has(c.id));
};
export const getUserByEmail = (email) => USERS.find(u => u.email === email) || null;
export const getRepById = (repId) => REPS.find(r => r.id === repId) || null;
export const getClientById = (clientId) => CLIENTS.find(c => c.id === clientId) || null;
